import { inject, injectable } from 'inversify';
import DeliveryScheduleRepository from 'src/features/checkout/data/repositories/DeliveryScheduleRepository';

type GetDeliveryScheduleConfigUseCaseParams = {
  accessToken: string;
};

@injectable()
class GetDeliveryScheduleConfigUseCase {
  @inject(DeliveryScheduleRepository)
  private deliveryScheduleRepository!: DeliveryScheduleRepository;

  async execute({ accessToken }: GetDeliveryScheduleConfigUseCaseParams) {
    return this.deliveryScheduleRepository.getDeliverySchedule({ accessToken });
  }
}

export default GetDeliveryScheduleConfigUseCase;
